module.exports = __webpack_public_path__ + "media/images/front/top/4-bbd6770b1d6bdacbca3717c0f8270d81.jpg";